import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';

import { SnackBarService } from 'src/app/shared/services/snack-bar.service';

@Component({
    selector: 'pme-snack-bar',
    templateUrl: 'snack-bar.component.html',
    standalone: false
})
export class SnackBarComponent implements OnInit, OnDestroy {
  openSnackBarEventSubscription: Subscription;

  constructor(public snackBar: MatSnackBar, private snackBarService: SnackBarService) { }

  ngOnInit() {
    this.openSnackBarEventSubscription = this.snackBarService.openSnackBarEvent.subscribe((data) => {
      this.openSnackBar(data);
    }, (err) => {
      // console.log(err);
    });
  }

  ngOnDestroy() {
    this.openSnackBarEventSubscription.unsubscribe();
  }

  private openSnackBar(snackBarData: any = {}) {
    const snackBarRef = this.snackBar.open(snackBarData.message, snackBarData.actionMessage, {
      duration: 2500,
      horizontalPosition: 'left'
    });

    snackBarRef.onAction().subscribe(() => {
      if (snackBarData.undoFunction) {
        snackBarData.undoFunction.apply(snackBarData.context, snackBarData.undoFunctionArgs);
      }
    });
  }
}
